import React, { useState, useEffect } from 'react';
import { Container, Form, Row, Col, Card, Navbar, Button } from 'react-bootstrap';
import { List } from 'react-bootstrap-icons'; // Import List icon
import axios from 'axios';
import "../components/Default.css"; // Corrected import path

const BASE_URL = 'https://whapi.infosware-test.in'; // Define base URL

function LoginPage({ onToggleSidebar }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    setLoading(false); // Set loading to false when component mounts
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      // Send login request to backend
      const response = await axios.post(`${BASE_URL}/login`, { username, password });

      // If login is successful, redirect to dashboard and store permissions
      if (response.status === 200) {
        const { permissions } = response.data; // Get permissions from response

        // Store permissions in localStorage
        localStorage.setItem('permissions', JSON.stringify(permissions));

        // Redirect to dashboard
        window.location.href = '/dashboard';  // Reload the page to trigger useEffect for permissions
      }
    } catch (err) {
      // If login fails, display error message
      setError('Invalid username or password');
    }
  };

  if (loading) {
    return <div>Loading...</div>; // Show loading indicator while checking for permissions
  }

  return (
    <>
     <Navbar id='headerstyle' className=" p-2 d-flex justify-content-between">
      {/* Left Side - Title */}
      <div className="d-flex align-items-center">
        <Button variant="" className="me-2 d-lg-none" onClick={onToggleSidebar}>
          <List color="white" size={23} />
        </Button>
        <h3 className='text-white mx-4'>INVENTORY</h3>
      </div>
    </Navbar>
      <Container className="">
        <Row className="justify-content-center mt-5">
          <Col md={4}>
            <Card className='mt-5'>
              <Card.Body>
                <h2 className="text-center mb-4">Login Account</h2>
                <Form onSubmit={handleLogin}>
                  <Form.Group controlId="email" className="mb-3">
                    <Form.Label>Username:</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter username.."
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group controlId="password" className="mb-3">
                    <Form.Label>Password:</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Enter password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Form.Group>

                  <Button type="submit"  className="w-100 LoginButton">
                    Log In
                  </Button>
                </Form>
                {error && <div className="text-danger mt-3">{error}</div>}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default LoginPage;
